<script lang="ts">
  import CollectionDetails from "./components/dataset/CollectionDetails.svelte";
  import CollectionSummary from "./components/dataset/CollectionSummary.svelte";

  // getting metadata from the hugo side
  const datasetMetadata = JSON.parse(document.getElementById("datasetMetadata").innerHTML);

  // function transformDate(input: string): string {
  //     return input ? input.slice(0, 10) : 'undefined';
  // }
</script>

<div class="container-fluid">
  <div class="row">
    <main class="col">
      <!-- dataset title and summary followed by metadata links -->
      <div class="row dataset">
        <div class="col pt-3 ps-3">
          <div>
            <h2 style="color: white;">{datasetMetadata?.name}</h2>
          </div>
          <div>
            <p style="color: white;" class="lead">
              Browse information about the collection, including links to documentation and types of
              access.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col"></div>
      </div>
      <CollectionSummary summary={datasetMetadata?.ncei.description} />
      <CollectionDetails
        documentation={datasetMetadata?.ncei.links.documentation}
        accessLinks={datasetMetadata?.ncei.links.access}
        startDate={datasetMetadata?.ncei.access.search.when.startdate}
        endDate={datasetMetadata?.ncei.access.search.when.enddate}
        detailsLink={datasetMetadata?.ncei.links.other}
      />
      <div class="my-4"></div>
    </main>
  </div>
</div>
